var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { mapGetters } from 'vuex';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { UrlHelper } from '../../../helper/UrlWrapper';
import GoodService from '../../../api/GoodService';
var initFormData = {
    goods_type_id: [],
    keywords: '',
    depot_id: '',
    group: "",
};
var BillHeader = (function (_super) {
    __extends(BillHeader, _super);
    function BillHeader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.formData = __assign({}, initFormData);
        _this.goodCategoryList = [];
        _this.depotList = [];
        _this.groups = [];
        return _this;
    }
    BillHeader.prototype.normalizer = function (node) {
        return {
            id: node.goods_type_id,
            label: node.goods_type_name,
            children: node.children,
        };
    };
    BillHeader.prototype.created = function () {
        var _this = this;
        this.row = JSON.parse(sessionStorage.getItem("GOODITEM")) || "";
        this.viewType = localStorage.getItem("viewType");
        this.goodsType = localStorage.getItem("goodsType");
        this.goodId = localStorage.getItem("goodId");
        this.goodService = GoodService.getInstance();
        if (this.viewType == 1) {
            this.getCategoryTree();
        }
        if (this.viewType == 2) {
            this.getDepot();
        }
        this.goodService.getGroups({ isAll: 1 }).then(function (res) {
            _this.groups = Array.isArray(res.data.data) ? res.data.data : [];
            if (_this.groups.length) {
                _this.formData.group = _this.groups[0].group_id;
            }
        });
    };
    BillHeader.prototype.mounted = function () {
        this.search();
    };
    BillHeader.prototype.getCategoryTree = function () {
        var _this = this;
        this.goodService.getCategory({ level: 4 }).then(function (res) {
            var listData = Array.isArray(res.data.data) ? res.data.data : [];
            _this.goodCategoryList = listData;
        });
    };
    BillHeader.prototype.getDepot = function () {
        var _this = this;
        this.goodService.getSupplierdepotOptions({}).then(function (res) {
            var listData = Array.isArray(res.data.data) ? res.data.data : [];
            _this.depotList = listData;
        });
    };
    BillHeader.prototype.search = function () {
        var filter = __assign({}, this.formData);
        filter.goods_type_id = filter.goods_type_id && filter.goods_type_id.join(',');
        filter.group_id = this.formData.group;
        filter.supplier_goods_id = this.goodId;
        this.$emit('search', filter);
    };
    BillHeader.prototype.exportResult = function () {
        var url = "supplierclientapi/sale_report_summary/export_depot_detail?goods_type_id=" + (this.formData.goods_type_id || []).join(',');
        if (this.viewType == 2) {
            url = "supplierclientapi/sale_report_summary/export_goods_type_detail?goods_type_id=" + this.goodsType;
        }
        if (this.viewType == 3) {
            url = "supplierclientapi/sale_report_summary/export_by_goods_detail?supplier_goods_id=" + this.goodId + "&group_id=" + this.formData.group + "&goods_format_id=" + this.row.goods_format_id;
        }
        url = UrlHelper.addParam(url, 'depot_id', this.depot_id);
        url = UrlHelper.addParam(url, 'keywords', this.formData.keywords);
        url = UrlHelper.addParam(url, 'from', this.listFilter.from);
        url = UrlHelper.addParam(url, 'order_type', this.listFilter.order_type);
        url = UrlHelper.addParam(url, 'time_type', this.listFilter.time_type);
        url = UrlHelper.addParam(url, 's_time', this.listFilter.s_time);
        url = UrlHelper.addParam(url, 'e_time', this.listFilter.e_time);
        url = UrlHelper.addParam(url, 'business_keywords', this.listFilter.business_keywords);
        url = UrlHelper.addParam(url, 'token', this.user.token);
        location.href = url;
        window._czc.push(['_trackEvent', '按仓库查看详情', '按仓库查看详情导出结果']);
    };
    __decorate([
        Prop({
            required: true,
        })
    ], BillHeader.prototype, "depot_id", void 0);
    __decorate([
        Prop({
            required: true,
        })
    ], BillHeader.prototype, "listFilter", void 0);
    BillHeader = __decorate([
        Component({
            computed: __assign({}, mapGetters({
                user: 'user',
            })),
        })
    ], BillHeader);
    return BillHeader;
}(Vue));
export default BillHeader;
